
import { path } from "ramda";
import yotpoWidgetMixin from "~/mixins/yotpoWidgetMixin";

let jsHasBeenAddedSoSkipIt = false;

export default {
  mixins: [yotpoWidgetMixin],
  props: {
    selectedVariant: { type: Object, default: () => {} },
    image: { type: Object, default: () => {} },
    productId: { type: String, required: true },
  },

  head() {
    const skip = jsHasBeenAddedSoSkipIt;

    return {
      script: [
        {
          src: this.$config.yotpoWidgetSrc,
          body: true,
          async: true,
          skip,
          callback: () => {
            jsHasBeenAddedSoSkipIt = true;
          },
        },
      ],
    };
  },

  computed: {
    imgSrc() {
      return path(["src"], this.image);
    },
  },

  mounted() {
    this.checkForYotpo();
  },
};
